import { Component, OnInit, OnChanges, SimpleChanges, inject } from '@angular/core';
import { ClientReferralMatchOption } from 'app/core/models/client-referral-match-option.model';
import { handleSimpleChanges } from 'app/core/lib/component-utils';
import { ReferralMatchVerificationsService } from 'app/core/services/referral-match-verifications.service';
import { PatientPrescriberService } from 'app/core/services/patient-prescriber.service';
import { ReferralMatchVerificationsClientBaseComponent } from '../referral-match-verifications-client-base/referral-match-verifications-client-base.component';
import { ReferralsClientListingComponent } from '../../../shared/components/referrals-client-listing/referrals-client-listing.component';

@Component({
  selector: 'app-referral-match-verifications-client',
  templateUrl: './referral-match-verifications-client.component.html',
  styleUrls: ['./referral-match-verifications-client.component.scss'],
  imports: [ReferralsClientListingComponent]
})
export class ReferralMatchVerificationsClientComponent
  extends ReferralMatchVerificationsClientBaseComponent
  implements OnInit, OnChanges {
  private referralMatchVerificationsService = inject(ReferralMatchVerificationsService);
  private patientPrescriberService = inject(PatientPrescriberService);

  ngOnInit() {
    this.fetchClientReferralVerifications();

    this.patientPrescriberChangedSubscription = this.patientPrescriberService.patientPrescriberChanged.subscribe(
      ({ patientPrescriber }) => {
        if (patientPrescriber.id === this.patientPrescriber.id) {
          this.patientPrescriber = patientPrescriber;

          this.fetchClientReferralVerifications();
        }
      }
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    handleSimpleChanges(changes, (inputName: string) => {
      if (inputName === 'capture' || inputName === 'verificationChangeInProgress') {
        this.refreshReferralMatchOptions();
      }
    });
  }

  onReferralVerificationChange(option: ClientReferralMatchOption) {
    const updatedVerification = { ...option.verification };
    const updatedOption = { ...option };

    if (option.selected) {
      updatedVerification.peerClientReferralVerification = true;
    }
    updatedOption.verification = updatedVerification;

    this.referralMatchVerificationsService.updateForOption(
      this.patientPrescriber.id,
      updatedOption,
      this.verificationChange
    ).subscribe();
  }
}
